<template>
<div>
  <div>
  </div>
    <div>
<ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(onSubmit)">
       <div class="rounded-lg bg-smoke-100 p-4 md:py-7.5 md:px-12 xl:px-56">
        <div class="flex lg:mb-4 border-b border-dark-b text-xl md:text-2xl font-semibold">
          Billing Address
        </div>
        <div v-if="isAddressAvailable" class="pt-4 lg:pt-0 lg:text-lg">
          You can add new address and/or select another address.
        </div>
        <AddressSelection 
          @isAddressAvailable="addressStatus"
          :prevSelectedAddress="formData.billing_address_id_token"
          :isUserAvailable='isUserAvailable'
          @updateSelectedAddress="updateSelectedAddress"
        />
        <div class="flex border-b border-dark-b text-xl md:text-2xl font-semibold">
          Payment Method
        </div>
        <div class="lg:pt-12 pt-7">
            <div v-if="isCardAvailable" class="pb-2 lg:text-lg">
              You can add new credit card and/or select another credit card.
            </div>
            <CardPayment 
              @isCardAvailable="cardStatus"
              v-if="paymentMethod == 1" 
              :isUserAvailable='isUserAvailable'
              :prevSelectedCard="formData.credit_card_id" 
              @updateSelectedCard="updateSelectedCard"
            />
          <div class="text-xl md:text-2xl font-semibold pt-8 lg:pt-6">
            Accepted Payment Methods
          </div>
          <div class="flex flex-wrap w-full border-2 bg-white rounded-lg py-6">
            <div class="w-full lg:w-1/2">
              <img src="@/assets/images/stripeBadge.png">
            </div>
            <div class="w-full lg:w-1/2 text-xs px-2 lg:pl-4 lg:pt-2">
              Stripe has been audited by a PCI-certified auditor and is certified to PCI Service Provider Level 1. 
              This is the most stringent level of certification available in the payments industry.
              Learn more about security at Stripe
              <a
                href="https://stripe.com/docs/security/stripe"
                target="_blank"
                class="text-blue"
              >here.</a>
            </div>
          </div>
           <div class="flex justify-between md:justify-end pt-5 lg:pt-12 lg:pb-10 pb-8">
          <button 
            class="text-blue border-2 border-blue rounded-full  py-3 px-3 md:px-8 text-lg lg:text-xl font-bold mr-3"
            :class="{'opacity-50' : isSavingData}"
            @click="PreviousTab" 
          >
            Back
          </button>
          &nbsp;
          &nbsp;
          <br/>
          <button 
            type="submit"
              class="text-white rounded-full py-3 px-3 md:px-8 text-lg lg:text-xl font-bold"
              :disabled="!formData.credit_card_id || !formData.billing_address_id_token || isSavingData"
              :class="(!formData.credit_card_id || !formData.billing_address_id_token || isSavingData) ? 'opacity-50 bg-gray-600' : 'bg-blue'"
          >
            Save & Continue
          </button>
        </div>
        </div>
       </div>
    </form>
    <div class="text-center not-ready-section pb-3 pt-6">
        Not ready to commit? Questions? Let’s talk <br class="md:hidden"/> about your needs!
        <br/>
    </div>
    <div class="flex justify-center items-center">
      <button @click="getBookACallUrl" class="bg-theme  text-white rounded-full py-2 px-5 text-lg lg:text-xl font-semibold">
        Book a Call
      </button>
    </div>
  </ValidationObserver>
    </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CardPayment from './CardPayment.vue'
import AddressSelection from './AddressSelection.vue'

export default {
  name: "Payment",
  components: { 
    CardPayment,
    AddressSelection
  },
  props: {
    userData: {
      type: Object,
      default: null
    },
  },
  mounted() {
    if (!this.isUserLoggedIn) {
      this.LoginSelectionMode('buyer')
      this.$router.push({name: 'LoginFormv2'})
    }
    localStorage.removeItem('supplierCriteriaDetails');
    localStorage.removeItem('previousUrl');
    localStorage.removeItem('existingSourcingToken')
    localStorage.removeItem('activeTab')
  },
  computed: {
    ...mapGetters([
      'isUserLoggedIn'
    ])
  },
  created() {
    if (this.userData && this.userData.billing_address_id_token && this.userData.credit_card_id) {
      this.formData = this.userData
      this.isUserAvailable = true
      this.paymentMethod = 1
    } 
  },
  data() {
    return {
      formData: {
        credit_card_id: '',
        billing_address_id_token: null
      },
      isAddressAvailable : false,
      isCardAvailable: false,
      paymentMethod :1,
      open: false,
      cards: [],
      isUserAvailable:false,
      isSavingData: false
    };
  },
  methods: {
    ...mapActions([
      'linkPaymentAndAddress',
      'LoginSelectionMode'
    ]),
    updateSelectedAddress(id) {
      this.formData.billing_address_id_token = id
    },
    getBookACallUrl() {
      window.open(process.env.VUE_APP_BOOK_A_CALL_URL,'_blank');      
    },
    updateSelectedCard(id) {
      this.formData.credit_card_id = id
    },
    addressStatus(status) {
      this.isAddressAvailable = status
    },
    cardStatus(status) {
      this.isCardAvailable = status
    },
    PreviousTab() {
      this.$emit('changeTab')
    },
    async onSubmit() {
      this.isSavingData = true
      const payload = { 
        address_id_token: this.formData.billing_address_id_token,
        credit_card_id: this.formData.credit_card_id
      }

      this.$emit('updateSourcingForm', { paymentData: this.formData })
      let response = await this.linkPaymentAndAddress(payload)
      if (response) {
        this.$emit('getSummaryRecord', response)
        this.$emit('proceedNext')
      }
      this.isSavingData = false
    }
  }
};
</script>
<style lang="scss" scoped>
.not-ready-section {
  @screen md {
  font-size: 26px;
  line-height: 39px;
  font-weight: 700;
  }
  font-size: 24px;
  line-height: 28px;
  font-weight: 600;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
</style>
